import {
  ImageScaleView,
  type ImageScaleViewOpts,
} from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import type { Locale } from 'src/replicant/ruleset/locale';
import StateObserver from 'src/StateObserver';

/** Native 1080p dimensions for each localized Dream Drift title asset. */
const TITLE_DIMENSIONS: Record<Locale, { width: number; height: number }> = {
  en: { width: 802, height: 163 },
  ja: { width: 744, height: 145 },
};

/** Layout options accepted by the localized Dream Drift title component. */
type DreamDriftTitleOpts = Omit<
  ImageScaleViewOpts,
  'height' | 'image' | 'scaleMethod' | 'width'
>;

/** Localized Dream Drift title image sized for the game's native resolution. */
export default class DreamDriftTitle extends ImageScaleView {
  /**
   * Create the title using the asset matching the current user locale.
   *
   * @param opts Parent, position, and other layout options for the title.
   */
  constructor(opts: DreamDriftTitleOpts = {}) {
    // Select the localized asset and its corresponding source dimensions.
    const locale = StateObserver.getLocale();
    const dimensions = TITLE_DIMENSIONS[locale];

    // Render the title at the game's native 720p scale without distortion.
    super({
      ...opts,
      image: `assets/ui/dreamDrift/common/title_${locale}.png`,
      width: downscale(dimensions.width),
      height: downscale(dimensions.height),
      scaleMethod: 'contain',
    });
  }
}
